import api from '../api';
import notifSystem from '../notifSystem';
import store from '../store';
import { setDialog } from './dialog';

export function debrief(artisan, cb) {
  store.dispatch(
    setDialog({
      dialogProps: {
        middleAll: true,
        title: 'Debrief de l\'artisan'
      },
      contentProps: {
        debriefProcess: artisan.debriefProcess || {},
        companyName: artisan.companyName
      },
      name: 'DebriefDialog',
      open: true,
      actions: [{
        children: 'Valider',
        color: 'primary',
        onClick: ({ debriefProcess }, close) => {
          if (Object.keys(debriefProcess).length) {
            const debriefCount = Object.values(debriefProcess)
              .reduce((acc, curr) => curr.checked ? acc + 1 : acc, 0);
            const debriefMax = Object.keys(debriefProcess).length || 10;
            return api.artisans.patch(
              artisan._id,
              {
                debriefProcess,
                toDebrief: Math.trunc(debriefCount / debriefMax) !== 1,
              }
            )
              .then((res) => {
                notifSystem.success('Réussie', 'Débrief mis à jour');
                if (cb) {
                  cb(res.body().data());
                }
                close();
              }).catch((e) => notifSystem.error(e.name, e.message));
          }
          return close();
        }
      }]
    })
  );
}

export function askForDebrief(props, artisan) {
  try {
    api.artisans
      .custom('askForDebrief')
      .post({ artisanId: artisan._id });
    notifSystem.success(
      'Opération réussie',
      'Demande de debrief envoyée',
    );
  } catch (e) {
    notifSystem.error(
      e.name,
      e.message
    );
  }
}

export function cancelDebrief(props, artisan) {
  return api.artisans.patch(artisan._id, { toDebrief: false })
    .then(() =>
      notifSystem.success('Opération réussie', 'Demande de debrief annulée')
    ).catch((e) =>
      notifSystem.error(e.name, e.response ? e.response.data : e)
    );
}

export function checkDebriefProcess(debriefProcess = []) {
  const debriefCount = Object.values(debriefProcess)
    .reduce((acc, curr) => curr.checked ? acc + 1 : acc, 0);
  const debriefMax = Object.keys(debriefProcess).length || 10;
  return Math.trunc(debriefCount / debriefMax) !== 1;
}
